import { render, staticRenderFns } from "./v-title-bg.vue?vue&type=template&id=788a19b2&scoped=true"
var script = {}
import style0 from "./v-title-bg.vue?vue&type=style&index=0&id=788a19b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788a19b2",
  null
  
)

export default component.exports